import { render } from "./TableAcces.vue?vue&type=template&id=50f2b862&scoped=true"
import script from "./TableAcces.vue?vue&type=script&lang=js"
export * from "./TableAcces.vue?vue&type=script&lang=js"

import "./TableAcces.vue?vue&type=style&index=0&id=50f2b862&scoped=true&lang=css"

import exportComponent from "/data/opt/gitlab-runner/working-directory/podman-stable_v4.8.1/corpo/crp-cardex-webapp/src/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f2b862"]])

export default __exports__